import { render } from "./page10.vue?vue&type=template&id=23a543d8&scoped=true"
import script from "./page10.vue?vue&type=script&lang=js"
export * from "./page10.vue?vue&type=script&lang=js"

import "./page10.vue?vue&type=style&index=0&id=23a543d8&scoped=true&lang=less"

import exportComponent from "D:\\work\\mvgx-carbon-space-admin-site\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23a543d8"]])

export default __exports__